import { CONTENT_ASSISTANT_SETTINGS, hsContentAssistantConfig } from '../constants/hscontentgeneration';
import { getPluginSetting } from '../utils';
const isNotEmptyString = content => content.length > 0;
export const newlinesToParagraphs = content => {
  const splitContent = content.trim().split('\n');
  if (splitContent.length > 1) {
    return splitContent.filter(isNotEmptyString).map(line => `<p>${line}</p>`).join('');
  }
  return content.trim();
};
export function insertNodeAtEndOfHighlightedText(editor, newNode) {
  const bookmarkId = editor.selection.getBookmark().id;
  const endNode = editor.dom.get(`${bookmarkId}_end`);
  endNode.replaceWith(newNode);
  // Cleanup dom
  const startNode = editor.dom.get(`${bookmarkId}_start`);
  if (startNode) {
    editor.dom.remove(startNode);
  }
}
export function getIsHighlightingText(editor) {
  return editor.selection && !editor.selection.isCollapsed();
}
export function getCopilotSessionIdFromEditor(editor) {
  const caSettings = getPluginSetting(editor, CONTENT_ASSISTANT_SETTINGS);
  const {
    // @ts-expect-error incorrect setting type
    [hsContentAssistantConfig.COPILOT_COLLAB_CONTEXT_VALUE]: copilotCollabContextValue = {}
  } = caSettings;
  return copilotCollabContextValue.sessionId;
}